import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
  viewChild,
} from '@angular/core';

import { TranslocoDirective } from '@jsverse/transloco';
import { CurrencyFormatPipe } from '@pedix-workspace/pedixapp-shared-pipes';
import { ModalDialogComponent } from '@pedix-workspace/angular-ui-modal';
import { IconInfoComponent } from '@pedix-workspace/angular-ui-icons';
import { ButtonComponent } from '@pedix-workspace/angular-ui-button';
import { OrderTotalDetailsComponent } from '../total-details/total-details.component';
import { EndOrderTotals } from '../end-order-totals.service';

@Component({
  selector: 'pxw-order-totals-resume',
  templateUrl: './order-totals-resume.component.html',
  styleUrls: ['./order-totals-resume.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslocoDirective,
    CurrencyFormatPipe,
    OrderTotalDetailsComponent,
    ModalDialogComponent,
    IconInfoComponent,
    ButtonComponent,
  ],
})
export class OrderTotalsResumeComponent {
  readonly totalDetailsDialog = viewChild.required<ModalDialogComponent>('totalDetailsDialog');

  readonly endOrderTotals = input.required<EndOrderTotals>();
  readonly totalLabel = input<string>('Total');
  readonly viewDetailsLabel = input<string>('Ver detalle');
  readonly confirmOrderText = input<string>();
  readonly formId = input<string>();
  readonly disabled = input<boolean>(false);
  readonly saving = input<boolean>(false);

  readonly confirmOrder = output<void>();

  displayTotalDetails = computed(
    () => this.endOrderTotals().finalAmount !== this.endOrderTotals().totalAmount,
  );

  onShowTotalDetails() {
    this.totalDetailsDialog()
      .open()
      .catch(() => {});
  }

  onClickConfirm(): void {
    if (this.formId()) {
      // When formId is set, the native form submit handles the action
      return;
    }
    this.confirmOrder.emit();
  }
}
